var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.processing)?_c('button',{staticClass:"todo-check",class:{ 'checked' : _vm.isDone },on:{"click":function($event){return _vm.toDoClicked()}}},[_c('i',{staticClass:"fas fa-check"})]):_c('div',{staticClass:"spinning-loader active"})])
}
var staticRenderFns = []

export { render, staticRenderFns }